import { useContext, useEffect, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; // remove if already imported globally
import "../assets/css/casino.css";
import cricketCrash from "../assets/images/Casino/cricket-crash-enter.webp";
import dragonTiger from "../assets/images/Casino/dragon-tiger-enter.webp";
import redBlueDuel from "../assets/images/Casino/red-blue-duel-enter.webp";
import coinToss from "../assets/images/Casino/coin-enter.webp";
import sevenUpDown from "../assets/images/Casino/7up7down-enter_3.webp";
import andarBahar from "../assets/images/Casino/andarbahar-enter_2.webp";
import rocket from "../assets/images/Casino/rocket-enter_1.webp";
import ghost from "../assets/images/Casino/ghost-enter_1.webp";
import beer from "../assets/images/Casino/beer-enter_1.webp";
import roulette from "../assets/images/Casino/roulette-enter_1.webp";
import comingSoon from "../assets/images/Casino/coming_1.webp";
import v48LuuXR from "../assets/images/Casino/luck-v48LuuXR.webp";
import RjfBua1q from "../assets/images/Casino/icon_close-RjfBua1q.webp";
import AuthContext from "../context/AuthContext";
import { isEmpty } from "lodash";
const ngAttr = "_ngcontent-oox-c41";
const ng = { [ngAttr]: "" };
const sidebarTabs = [
  {
    id: "home",
    gId: "iconHome 1",
    label: "home",
    active: true,
    iconFill: "#D92626",
    clipId: "clip0_623_4894",
    path: "M31.2078 13.047L18.8152 2.98888C17.1904 1.67037 14.8219 1.67037 13.197 2.98888L0.79189 13.047C-0.782966 14.3231 0.148199 16.8029 2.20426 16.8029H3.32916V27.8831C3.32916 29.0504 4.31032 30 5.51646 30H11.7846V22.839C11.7846 20.583 13.672 18.7565 16.003 18.7565C18.334 18.7565 20.2214 20.583 20.2214 22.839V29.994H26.4895C27.6957 29.994 28.6768 29.0444 28.6768 27.8771V16.8029H29.8017C31.8515 16.8029 32.7827 14.3231 31.2078 13.047Z",
  },
  {
    id: "fav",
    gId: "iconFav",
    label: "fav",
    iconFill: "white",
    path: "M29.2978 14.7517C30.2916 13.7592 29.7351 12.052 28.3437 11.8535L21.6653 10.9007C21.1087 10.8212 20.6317 10.4639 20.3932 9.98751L17.4117 3.95284C16.7757 2.68239 14.9868 2.68239 14.3905 3.95284L11.4091 9.98751C11.1705 10.5036 10.6935 10.8212 10.137 10.9007L3.45851 11.8535C2.06716 12.052 1.51062 13.7592 2.50444 14.7517L7.31452 19.4762C7.71205 19.8733 7.91081 20.4291 7.79155 20.9849L6.63872 27.6151C6.43996 29.0047 7.91081 30.0369 9.14315 29.4017L15.1061 26.2652C15.5831 25.9873 16.1794 25.9873 16.6962 26.2652L22.6591 29.4017C23.8914 30.0369 25.3623 29.0047 25.1237 27.6151L23.9709 20.9849C23.8914 20.4291 24.0504 19.8733 24.4479 19.4762L29.2978 14.7517Z",
  },
  {
    id: "recent",
    gId: "iconRecent",
    label: "recent",
    iconFill: "white",
    evenOdd: true,
    path: "M18.165 3.47656C23.3181 4.21272 27.735 7.78831 29.3125 12.7836C30.8899 17.7263 29.4176 23.3001 25.6843 26.9282C21.8984 30.4513 16.2195 31.5029 11.3819 29.5048C6.59694 27.5066 3.33684 22.932 3.02135 17.7263C2.70585 12.2052 5.91337 6.94699 10.9087 4.68596C11.4345 4.42304 12.0129 4.52821 12.3284 5.05403C12.5913 5.47469 12.4862 6.26342 11.9603 6.47375C7.17534 8.6822 4.23074 13.9404 5.33497 19.1987C6.17628 23.4052 9.3838 26.8757 13.5904 27.9799C17.8495 29.0841 22.4242 27.6118 25.2636 24.2465C28.1031 20.9339 28.7341 15.9911 26.8411 12.0475C25.1585 8.57704 21.8458 6.21084 18.1124 5.63244V5.79018V5.84276C18.1124 6.68408 16.9031 7.2099 16.3247 6.52633C16.0709 6.27262 15.8422 5.99393 15.6213 5.7247C15.5216 5.60333 15.4236 5.48389 15.3256 5.36952C15.2677 5.28851 15.2073 5.2126 15.1483 5.13841C14.9391 4.87553 14.7472 4.63438 14.7472 4.2653C14.7472 4.05497 14.7998 3.84464 14.9049 3.68689C14.9668 3.59402 15.0652 3.51938 15.1678 3.4415C15.2395 3.3871 15.3133 3.33111 15.3782 3.26623L16.4824 2.31975C16.8505 2.00426 17.2711 1.8991 17.6918 2.10943C18.0073 2.26717 18.2702 2.63525 18.2702 3.05591C18.2702 3.16107 18.2176 3.31882 18.165 3.47656ZM16.4298 26.4552C11.1716 26.4552 6.85986 22.196 6.85986 16.8852C6.85986 11.5744 11.119 7.2627 16.4298 7.2627C21.7406 7.2627 25.9998 11.5744 25.9998 16.8852C25.9998 22.1435 21.6881 26.4552 16.4298 26.4552ZM15.3782 11.2589V16.3594V17.0956C15.3782 17.674 15.8514 18.1472 16.4298 18.1472H20.5312C21.0571 18.1472 21.5829 17.674 21.5829 17.0956C21.5829 16.5172 21.1096 16.0439 20.5312 16.0439H17.4815V11.9951V11.2589C17.4815 10.7331 17.0082 10.2073 16.4298 10.2073C15.8514 10.2073 15.3782 10.6805 15.3782 11.2589Z",
  },
];

// Each slide = one slick column holding 1-2 cards
const casinoSlides = [
  [
    { id: 3, img: cricketCrash, alt: "Cricket Crash" },
    {
      id: 2,
      img: dragonTiger,
      alt: "Dragon Tiger",
      platForm: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-004",
    },
  ],
  [
    {
      id: 5,
      img: redBlueDuel,
      alt: "Red Blue Duel",
      platForm: "SEXYBCRT",
      gameType: "LIVE",
      casinoType: "MX-LIVE-010",
    },
    {
      id: 4,
      img: coinToss,
      alt: "Fortune Flip",
      platForm: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-006",
    },
  ],
  [
    {
      id: 6,
      img: sevenUpDown,
      alt: "7up7down",
      platForm: "KINGMAKER",
      gameType: "TABLE",
      casinoType: "KM-TABLE-028",
    },
    {
      id: 1,
      img: andarBahar,
      alt: "Andar Bahar",
      platForm: "KINGMAKER",
      gameType: "TABLE",
      casinoType: "KM-TABLE-032",
    },
  ],
  [
    {
      id: 7,
      img: rocket,
      alt: "Rocket",
      platForm: "KINGMAKER",
      gameType: "TABLE",
      casinoType: "KM-TABLE-041",
    },
    { id: 8, img: ghost, alt: "Ghost" },
  ],
  [
    { id: 9, img: beer, alt: "Beer Game" },
    {
      id: 10,
      img: roulette,
      alt: "Roulette",
      platForm: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-001",
    },
  ],
  [{ id: 11, img: comingSoon, alt: "Coming Soon" }],
];

const sliderSettings = {
  dots: true,
  arrows: false,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
};

// ---------- Small components ----------
const SidebarTab = ({ tab }) => (
  <div {...ng} className={`tab ${tab.active ? "bg-white" : "bg-transparent"}`}>
    <div {...ng} className="tab__inner">
      <svg
        {...ng}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        fill="none"
        className="icon"
      >
        <g
          {...ng}
          id={tab.gId}
          clipPath={tab.clipId ? `url(#${tab.clipId})` : undefined}
        >
          <path
            {...ng}
            d={tab.path}
            fill={tab.iconFill}
            fillRule={tab.evenOdd ? "evenodd" : undefined}
            clipRule={tab.evenOdd ? "evenodd" : undefined}
          />
        </g>
        {tab.clipId && (
          <defs {...ng}>
            <clipPath {...ng} id={tab.clipId}>
              <rect {...ng} width={32} height={32} fill="white" />
            </clipPath>
          </defs>
        )}
      </svg>
      <div
        {...ng}
        className={`tab__name ${tab.active ? "color-red" : "color-white"}`}
      >
        {tab.label}
      </div>
    </div>
  </div>
);

// ---------- Main component ----------
const CasinoModalNew = ({ onClose }) => {
  const lobbyRef = useRef(null);
  const { launchCasino, user } = useContext(AuthContext);
  // react-slick renders its own wrappers (slick-list, slick-track, slick-slide...),
  // so tag them with the same scoped attribute the original Angular markup had.
  useEffect(() => {
    lobbyRef.current
      ?.querySelectorAll(".slick-slider, .slick-slider *")
      .forEach((el) => el.setAttribute(ngAttr, ""));
  }, []);

  return (
    <div className="casino-new-style">
      <div
        {...ng}
        ref={lobbyRef}
        id="lobby"
        className="lobby ng-star-inserted slide-up displayblock"
      >
        <div {...ng} className="gmnheader" style={{ marginTop: "-27px" }}>
          <div {...ng} className="position-relative w-100">
            <span {...ng} className="position-relative">
              <img {...ng} src={v48LuuXR} style={{ width: 113, height: 23 }} />
              <span {...ng} className="luckspan">
                Luckco7
              </span>
            </span>
          </div>
          <div
            onClick={() => onClose()}
            {...ng}
            data-v-302cf84b=""
            className="header__close"
          >
            <img {...ng} src={RjfBua1q} alt="" className="icon-promote" />
          </div>
        </div>

        <div {...ng} className="header-casino-footer w-full" />

        <ul {...ng} className="gamel-left-sidebar-block game-grid">
          <div
            {...ng}
            data-v-1b6a9913=""
            className="gamel-left-sidebar menu menu--on"
          >
            {/* Sidebar background shape */}
            <svg
              {...ng}
              xmlns="http://www.w3.org/2000/svg"
              width={154}
              height={466}
              viewBox="0 0 154 466"
              fill="none"
              className="menu__bg"
            >
              <g {...ng} filter="url(#filter0_di_1235_1842)">
                <mask
                  {...ng}
                  id="path-1-outside-1_1235_1842"
                  maskUnits="userSpaceOnUse"
                  x={-18}
                  y={0}
                  width={161}
                  height={469}
                  fill="black"
                >
                  <rect {...ng} fill="white" x={-18} width={161} height={469} />
                  <path
                    {...ng}
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M101 1H-17V468H101V274H114C129.464 274 142 261.464 142 246V223C142 207.536 129.464 195 114 195H101V1Z"
                  />
                </mask>
                <path
                  {...ng}
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M101 1H-17V468H101V274H114C129.464 274 142 261.464 142 246V223C142 207.536 129.464 195 114 195H101V1Z"
                  fill="url(#paint0_linear_1235_1842)"
                  shapeRendering="crispEdges"
                />
                <path
                  {...ng}
                  d="M-17 1V0H-18V1H-17ZM101 1H102V0H101V1ZM-17 468H-18V469H-17V468ZM101 468V469H102V468H101ZM101 274V273H100V274H101ZM101 195H100V196H101V195ZM-17 2H101V0H-17V2ZM-16 468V1H-18V468H-16ZM101 467H-17V469H101V467ZM100 274V468H102V274H100ZM114 273H101V275H114V273ZM141 246C141 260.912 128.912 273 114 273V275C130.016 275 143 262.016 143 246H141ZM141 223V246H143V223H141ZM114 196C128.912 196 141 208.088 141 223H143C143 206.984 130.016 194 114 194V196ZM101 196H114V194H101V196ZM100 1V195H102V1H100Z"
                  fill="#FF3939"
                  fillOpacity="0.77"
                  mask="url(#path-1-outside-1_1235_1842)"
                />
              </g>
              <defs {...ng}>
                <filter
                  {...ng}
                  id="filter0_di_1235_1842"
                  x={-28}
                  y={-10}
                  width={181}
                  height={489}
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood
                    {...ng}
                    floodOpacity={0}
                    result="BackgroundImageFix"
                  />
                  <feColorMatrix
                    {...ng}
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset {...ng} />
                  <feGaussianBlur {...ng} stdDeviation={5} />
                  <feComposite {...ng} in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    {...ng}
                    type="matrix"
                    values="0 0 0 0 1 0 0 0 0 0.11888 0 0 0 0 0.11888 0 0 0 0.6 0"
                  />
                  <feBlend
                    {...ng}
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_1235_1842"
                  />
                  <feBlend
                    {...ng}
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_1235_1842"
                    result="shape"
                  />
                  <feColorMatrix
                    {...ng}
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset {...ng} />
                  <feGaussianBlur {...ng} stdDeviation={5} />
                  <feComposite
                    {...ng}
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2={-1}
                    k3={1}
                  />
                  <feColorMatrix
                    {...ng}
                    type="matrix"
                    values="0 0 0 0 0.975326 0 0 0 0 0.287359 0 0 0 0 0.287359 0 0 0 0.6 0"
                  />
                  <feBlend
                    {...ng}
                    mode="normal"
                    in2="shape"
                    result="effect2_innerShadow_1235_1842"
                  />
                </filter>
                <linearGradient
                  {...ng}
                  id="paint0_linear_1235_1842"
                  x1="62.5"
                  y1={1}
                  x2="62.5"
                  y2={468}
                  gradientUnits="userSpaceOnUse"
                >
                  <stop {...ng} stopColor="#F35151" />
                  <stop {...ng} offset={1} stopColor="#D31919" />
                </linearGradient>
              </defs>
            </svg>

            <svg
              {...ng}
              xmlns="http://www.w3.org/2000/svg"
              width={20}
              height={205}
              viewBox="0 0 20 205"
              fill="none"
              className="menu__bg__helper"
            >
              <rect
                {...ng}
                x={-104}
                y={6}
                width="123.612"
                height="193.56"
                rx={30}
                fill="url(#paint0_linear_2607_123)"
              />
              <defs {...ng}>
                <linearGradient
                  {...ng}
                  id="paint0_linear_2607_123"
                  x1="-42.1941"
                  y1={6}
                  x2="-42.1941"
                  y2="199.56"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop {...ng} stopColor="#F35151" />
                  <stop {...ng} offset={1} stopColor="#D31919" />
                </linearGradient>
              </defs>
            </svg>

            {/* Tabs: home / fav / recent */}
            {sidebarTabs.map((tab) => (
              <SidebarTab key={tab.id} tab={tab} />
            ))}

            <div {...ng} className="arrow__click-area">
              <svg
                {...ng}
                xmlns="http://www.w3.org/2000/svg"
                width={10}
                height={15}
                viewBox="0 0 10 15"
                fill="none"
                className="arrow arrow__left"
              >
                <path
                  {...ng}
                  d="M1.87667 14.7323L9.60314 8.33347C9.72761 8.23033 9.82753 8.10238 9.89603 7.95841C9.96453 7.81444 10 7.65786 10 7.4994C10 7.34094 9.96453 7.18435 9.89603 7.04038C9.82753 6.89641 9.72761 6.76847 9.60314 6.66533L1.87667 0.266519C1.13917 -0.344155 -5.79106e-07 0.162147 -5.4248e-07 1.10059L-4.29305e-08 13.9C-6.30398e-09 14.8385 1.13917 15.3448 1.87667 14.7323Z"
                  fill="white"
                />
              </svg>
            </div>
          </div>

          <Slider
            style={{ marginLeft: "10px" }}
            {...sliderSettings}
            className="parly-slider bottom-casino-slider casino-slider"
          >
            {casinoSlides.map((cards, index) => (
              <div {...ng} key={index} className="casino-column">
                {cards.map((card) => (
                  <div
                    onClick={() => {
                      if (!isEmpty(user)) {
                        launchCasino(card);
                        onClose();
                      }
                    }}
                    {...ng}
                    key={card.id}
                    id={card.id}
                    className="casino-card"
                  >
                    <img
                      {...ng}
                      src={card.img}
                      alt={card.alt}
                      className="casino-card__image"
                    />
                  </div>
                ))}
              </div>
            ))}
          </Slider>
        </ul>
      </div>
    </div>
  );
};

export default CasinoModalNew;
